import ProductService from '_services/rest/modules/product';

export default {
  state: {
    groups: null,
    product: null,
    productList: null,
    productUnits: null,
    productFilters: null,
    productVariationsList: null,
    productVariationsPriceList: null,
  },
  mutations: {
    setGroups(state, response) {
      state.groups = response;
    },
    setProduct(state, response) {
      state.product = response;
    },
    setProductList(state, response) {
      state.productList = response;
    },
    setProductUnits(state, response) {
      state.productUnits = response;
    },
    setProductFilters(state, response) {
      state.productFilters = response;
    },
    setProductVariations(state, response) {
      state.productVariationsList = response;
    },
    setProductVariationsPrice(state, response) {
      state.productVariationsPriceList = response;
    },
    addProductMaterial(state, material) {
      state.product.materials.push(material);
    },
    removeProductMaterial(state, index) {
      state.product.materials.splice(index, 1);
    },
  },
  actions: {
    getGroups({ commit }, params) {
      return ProductService.getGroups(params)
        .then(response => {
          commit('setGroups', response);
        });
    },
    getProductUnits({ commit }, params) {
      return ProductService.getProductUnits(params)
        .then(response => {
          commit('setProductUnits', response);
        });
    },
    getProductFilters({ commit }) {
      return ProductService.getProductFilters()
        .then(response => {
          commit('setProductFilters', response);
        });
    },
    getProductList({ commit }, params) {
      return ProductService.getList(params)
        .then(response => {
          commit('setProductList', response);
        });
    },
    getProductVariations({ commit }, params) {
      return ProductService.getProductVariations(params)
        .then(response => {
          commit('setProductVariations', response);
        });
    },
    getProductVariationsPrice({ commit }, params) {
      return ProductService.getproductVariationsPriceList(params)
        .then(response => {
          commit('setProductVariationsPrice', response);
        });
    },
    getProduct({ commit }, params) {
      return ProductService.getProductById(params)
        .then(response => {
          commit('setProduct', response);
        });
    },
    setProduct({ commit }, params) {
      commit('setProduct', params);
    },
  },
};
